module.exports = __webpack_public_path__ + "font/ef7c6637c68f269a882e73bcb57a7f6a.woff2";